module.exports = __webpack_public_path__ + "4b881c3cef934955aa338bb5650e3cf8.svg";